<div class="filter">
    @if (title) {
        <h4
            class="filter__title"
        >
            {{ title }}
        </h4>
    }

    <ng-content/>
</div>
